export default __webpack_public_path__ + "static/media/07-2.0c89fe4c.jpg";